
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { useNavigate } from "react-router-dom";
import Api from "../../../../constants/Api";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import { ApiError } from "../../../components/Common/ApiError";

const CommissionNew = () => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        product: Yup.object().nullable().required(t('validation.required.product')),
        score: Yup.number().required(t('gamification.validation.required.score'))
    });

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            product: null,
            score: 0
        },
        validationSchema: formSchema,
        onSubmit: values => {
            let payload = {
                id: getId(entityData),
                score: values.score,
                product: {
                    id: values.product.value
                },
                status: convertBooleanToStatus(status)
            }
            
            // Aciona a api
            sendToApi(Api.gamification.score, payload, () => {
                if(entityData == null) {
                    formik.resetForm();
                } else {
                    navigate(MenuConfig.gamification.score.route);
                }
            }, (error) => {
                ApiError(error)
                formik.setSubmitting(false);
            });
        },
    });

    // Valida o form e em seguida submete os dados. Aciona o onSubmit do formik.
    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('gamification.label')}
                childMenu={t('gamification.score')}
                activeMenu={t('new')}
                child={<Form formik={formik} status={status} setStatus={setStatus} entityData={entityData}/>}
                setEntityData={setEntityData}
                path={Api.gamification.score}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.gamification.score.route}
            />
        </>
    );
}

export default CommissionNew;